import Footer from "@/components/Footer";
import { useTableFiltersCursor } from "@/hooks/useTableFiltersCursor";
import { Box, Card } from "@chakra-ui/react";
import { useState } from "react";
import CreateContractModal from "../contracts/components/CreateContractModal";
import InductionCallout from "../induction/components/InductionCallout";
import { SCREENING_TABLE_COLUMNS } from "./columns";
import Filters from "./components/Filters";
import ScreeningDetailModal from "./components/ScreeningDetailModal";
import Table from "./components/Table";
import { Screening, ScreeningFilters } from "./types";
import { useFetchScreenings } from "./useFetchScreenings";

const TABLE_KEY = "protectScreenings";

const ScreeningsTab = (): JSX.Element => {
  const { queryFilters, setQueryFilters, cursor, setCursor } =
    useTableFiltersCursor<ScreeningFilters>(TABLE_KEY);
  const { screenings, nextCursor, isLoading } = useFetchScreenings(
    queryFilters,
    cursor
  );
  const [selectedScreening, setSelectedScreening] = useState<
    Screening | undefined
  >(undefined);
  const [contractScreening, setContractScreening] = useState<
    Screening | undefined
  >(undefined);

  const handleCreateContract = (screening: Screening) => {
    setSelectedScreening(undefined);
    setContractScreening(screening);
  };

  return (
    <Box display="flex" flexDirection="column" gap="1.5rem" flex="1" minH={0}>
      <InductionCallout />
      <Card.Root
        borderRadius="lg"
        border="none"
        display="flex"
        flexDirection="column"
        gap="1rem"
        flexShrink={0}
        boxShadow="rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
      >
        <Card.Body p="4">
          <Filters
            queryFilters={queryFilters}
            setQueryFilters={setQueryFilters}
          />
        </Card.Body>
      </Card.Root>
      <Table
        screenings={screenings}
        isLoading={isLoading}
        onSelect={setSelectedScreening}
        onCreateContract={handleCreateContract}
      />
      <ScreeningDetailModal
        open={!!selectedScreening}
        onClose={() => setSelectedScreening(undefined)}
        onCreateContract={handleCreateContract}
        screening={selectedScreening}
      />
      <CreateContractModal
        open={!!contractScreening}
        onClose={() => setContractScreening(undefined)}
        screening={contractScreening}
      />
      <Footer
        tableProps={{
          fileName: "estudios",
          items: screenings,
          columns: SCREENING_TABLE_COLUMNS,
          pagination: { tableKey: TABLE_KEY, nextCursor, setCursor, cursor },
        }}
      />
    </Box>
  );
};

export default ScreeningsTab;
